import React from "react";
import { Link } from "react-router-dom";
import AuthImage from "../images/auth-image.jpg";
import { brandLogoUrl, brandSystemName } from "../branding";
import { LoginForm } from "./LoginForm";

export const SignInPage = () => {
  return (
    <main className="bg-white dark:bg-slate-900">
      <div className="relative md:flex">
        {/* Content */}
        <div className="md:w-1/2">
          <div className="flex h-full min-h-[100dvh] flex-col after:flex-1">
            {/* Header */}
            <div className="flex-1">
              <div className="flex h-16 items-center justify-between px-4 sm:px-6 lg:px-8">
                <Link className="block" to="/">
                  <img src={brandLogoUrl} width="60" height="60" alt="Logo" className="object-contain" />
                </Link>
              </div>
            </div>

            <div className="mx-auto w-full max-w-sm px-4 py-8">
              <h1 className="mb-6 text-3xl font-bold text-slate-800 dark:text-slate-100">
                Witaj w systemie <span className="text-primary-500">{brandSystemName}</span>
              </h1>
              <LoginForm />
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 right-0 top-0 hidden md:block md:w-1/2" aria-hidden="true">
          <img
            className="h-full w-full object-cover object-center"
            src={AuthImage}
            width="760"
            height="1024"
            alt="Authentication"
          />
        </div>
      </div>
    </main>
  );
};
